import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import useTranslation from "../../../hooks/use_translation"

const Email = () => {
  const id = "email"

  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      id={id}
      _label="Email"
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
    />
  )
}

export default Email
